export const options = [
  { value: "ar", label: "العربية" },
  { value: "en", label: "English" },
];
